import { getWafEventStatus } from "./wafEventListUtils";

/** Display / filter label for firewall "Attack Type" similar-events card. */
export function getFirewallAttackTypeLabel(event = {}) {
  const fwType = event?.type?.[0];
  if (fwType && typeof fwType === "object" && fwType.attack_type) {
    return String(fwType.attack_type);
  }
  if (Array.isArray(event.attack_types) && event.attack_types[0]) {
    return String(event.attack_types[0]);
  }
  if (Array.isArray(event.categories_detected) && event.categories_detected[0]) {
    return String(event.categories_detected[0]);
  }
  if (event.rule_details?.[0]?.ruleId) {
    return String(event.rule_details[0].ruleId);
  }
  if (typeof fwType === "string" && fwType.trim()) {
    return fwType.trim();
  }
  return null;
}

/** Map ViewSimilarEventsPanel key → listing filter pill for firewall events. */
export function resolveFirewallSimilarFilter(filterType, event) {
  if (!event) return null;

  switch (filterType) {
    case "ip":
      return {
        id: "src_ip",
        label: "IP Address",
        value: event.src_ip || event.ip,
      };
    case "hostname":
      return {
        id: "hostname",
        label: "Hostname",
        value: event.host_name || event.hostname || event.host,
      };
    case "uri":
      return {
        id: "uri",
        label: "URI Path",
        value: event.uri || event.path || event.request_uri,
      };
    case "country":
      return {
        id: "country",
        label: "Country",
        value: event.country_iso_code || event.country_name,
      };
    case "status":
      return {
        id: "status",
        label: "Status",
        value: getWafEventStatus(event),
      };
    case "attack_type":
    case "detection_type": {
      const value = getFirewallAttackTypeLabel(event);
      if (!value) return null;
      const ruleId = event.rule_details?.[0]?.ruleId
        || (Array.isArray(event.attack_types) ? event.attack_types[0] : null);
      return {
        id: ruleId ? "rule_id" : "block_reason",
        label: "Attack Type",
        value,
      };
    }
    default:
      return null;
  }
}

/** v3 envelope for ViewSimilarEventsPanel from a firewall list/detail row. */
export function buildFirewallSimilarEventShape(eventData, { sourceIp, countryIso, headerPath }) {
  const attackLabel = getFirewallAttackTypeLabel(eventData);
  return {
    attacker: {
      source_ip: sourceIp,
      geo: { country_iso: countryIso },
    },
    target: {
      host: eventData.host_name || eventData.host,
      uri: headerPath,
      path: headerPath,
    },
    attack_types: attackLabel ? [attackLabel] : [],
    primary_intent: attackLabel ? { intent_name: attackLabel } : undefined,
    assessment: { action: eventData.action || eventData.waf_action },
  };
}
